module.exports = __webpack_public_path__ + "static/media/12. Resurgir, Mixta en cartón pluma, 50 x 70 cm, 2011 copy.ad1c749e.png";